import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// 引入主页面
import app from "../App.vue"

//

//引入首页
import home from "../homepages/homemain.vue"

//引入主页打开部分
import main from "../homepages/main.vue"


//引入产品页



//引入解决方案页面
import solution from "../homepages/solution.vue"

// 引入自动化监测页面
import subway from "../homepages/solutionpage/subway.vue"
import tunnel from "../homepages/solutionpage/tunnel.vue"
import bridge from "../homepages/solutionpage/bridge.vue"
import dam from "../homepages/solutionpage/dam.vue"
import side from "../homepages/solutionpage/side.vue"
import pit from "../homepages/solutionpage/pit.vue"
import gangue from "../homepages/solutionpage/gannue.vue"
import relic from "../homepages/solutionpage/relic.vue"
import damage from "../homepages/solutionpage/damage.vue"


//引入案例页面
import cases from "../homepages/cases.vue"
// 引入具体案例页面
import subulei from "../homepages/casepage/subulei.vue"
import chongqing from "../homepages/casepage/chongqing.vue"
import guangdong from "../homepages/casepage/guangdong.vue"
import lianhe from "../homepages/casepage/lianhe.vue"
import shaoguan from "../homepages/casepage/shaoguan.vue"
import tiankeng from "../homepages/casepage/tiankeng.vue"


//引入QimMoS软件下载页面
import download from "../homepages/download.vue"
//引入关于我们页面
import aboutus from "../homepages/aboutus.vue"


//引入登录页
import login from "../login/login.vue"



//引入注册页
import register from "../register/register.vue"


// 引入管理员主页面
import admin from "../admin/testecharts.vue"


//引入一般用户页面
import account from "../account/homepage.vue"

//引入rocbox页面
import rocbox from "../homepages/rocbox.vue"

//引入忘记密码页面
import password from "../password/password.vue"







export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path:"",
      component:app,
      children:[
        {
          path:"/",
          redirect:"/login"
         },
         {
           path:"/home",
           component:home,
           children:[
             {
               path:"/homepage",
               component:main
             },
             {
               path:"/solution",
               component:solution
             },
             {
               path:"/cases",
               component:cases
             },
             {
               path:"/rocbox",
               component:rocbox
             },
             {
               path:"/subway",
               component:subway
             },
             {
               path:"/tunnel",
               component:tunnel
             },
             {
               path:"/bridge",
               component:bridge
             },
             {
               path:"/dam",
               component:dam
             },
             {
               path:"/side",
               component:side
             },
             {
               path:"/pit",
               component:pit
             },
             {
               path:"/gangue",
               component:gangue
             },
             {
               path:"/relic",
               component:relic
             },
             {
               path:"/damage",
               component:damage
             },
             {
               path:"/subulei",
               component:subulei
             },
             {
               path:"/chongqing",
               component:chongqing
             },
             {
               path:"/shaoguan",
               component:shaoguan
             },
             {
               path:'/lianhe',
               component:lianhe
             },
             {
               path:"/guangdong",
               component:guangdong
             },
             {
               path:"/tiankeng",
               component:tiankeng
             },
             {
               path:"/download",
               component:download
             },
             {
               path:"/aboutus",
               component:aboutus
             }
           ]
         },
         {
           path:"/login",
           component:login
         },
         {
           path:"/register",
           component:register
         },
         {
           path:"/admin",
           component:admin
         },
         {
           path:"/account",
           component:account
         },{
           path:"/password",
           component:password
         }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js